import * as types from "../types";

const initialState = {
    loading: false,
    accessToken: null,
    auction_id:null,
    uploadedAuctionInvResult: null,
    error: null
}

export default function fetchAuctionUploadedInvListReducer(state = initialState, action){
    
    switch(action.type){
        case types.FETCH_UPLOADED_AUCTION_INVENTORY_REQUEST :
            return{
                ...state,
                loading: true,
                accessToken: action.payload.accessToken,
                auction_id:action.payload.auction_id,
            }

        case types.FETCH_UPLOADED_AUCTION_INVENTORY_SUCCESS :
            return{
                ...state,
                loading: false,
                uploadedAuctionInvResult: action.payload.uploadedAuctionInvResult,
            }

        case types.FETCH_UPLOADED_AUCTION_INVENTORY_FAILURE :
            return{
                ...state,
                loading: false,
                accessToken: null,
                auction_id:null,
                uploadedAuctionInvResult: null,
                error: action.payload.error
            }

        default :
        return state;

    }

}